/**
 * Typescript port of: [vendor/magento/module-wishlist-graph-ql/etc/schema.graphqls]
 */

import { GroupedProduct, ID, ProductInterface } from "./quote";

export interface BBNTCustomWishlistItemOption {
  sku?: string;
  parent_sku?: string;
}

export interface WishlistItem {
  /**
   * Int
   */
  id?: number;
  /**
   * Float
   */
  qty?: number;
  description?: string;
  added_at?: string;
  product?: ProductInterface | GroupedProduct;

  bbnt_custom_wishlist_item_option?: BBNTCustomWishlistItemOption;
}

export interface Wishlist {
  id?: ID;
  items?: WishlistItem[];
  items_count?: number;
  sharing_code?: string;
  updated_at?: string;
}

export enum WishListUserInputErrorType {
  PRODUCT_NOT_FOUND = "PRODUCT_NOT_FOUND",
  UNDEFINED = "UNDEFINED",
}

export interface WishListUserInputError {
  message: string;
  code: WishListUserInputErrorType;
}

export interface AddProductsToWishlistOutput {
  wishlist: Wishlist;
  user_errors: WishListUserInputError[];
}

export interface WishlistItemInput {
  sku: string;
  quantity: number;
  parent_sku?: string;
  selected_options?: ID[];
}
